import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const target = document.getElementById('ess-react-app');
const root = createRoot(target);

root.render(
	<App
		devRootPath={target.dataset.devrootpath}
		apiKey={target.dataset.apikey}
		loginRedirect={target.dataset.loginredirect}
		colour={target.dataset.colour}
		FID={target.dataset.fid}
		variant={target.dataset.variant}
	/>
);
